import React, { useState, useEffect } from "react";
import { Container, Col, Row, Accordion, Button, Image, Modal } from "react-bootstrap";
import { NavLink, useNavigate,useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import trash2 from '../assets/img/trash-2.jpg';
import trash3 from '../assets/img/trash-3.jpg';
import trash4 from '../assets/img/trash-4.jpg';
import score from '../assets/icons/score.png';
import order from '../assets/icons/order.png'
import OrderForm from "./OrderForm";
import { apiUrl } from "../commons/inFormTypes";
import { ProfileUrl } from "../commons/IPAddress";
import { IPUrl } from "../commons/IPAddress";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo1 from '../assets/img/alert8.png'
import BigLoaders from "../components/BigLoaders";
import Ripples from 'react-ripples'

function Dashboard() {
  let {requestId} = useParams()
  const [radioItem, setRadioItem] = useState(0);
  const [snip, setSnip] = useState(false);
  const [orderId, setOrderId] = useState(0);
  const [Stchange, setstchange] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const [listOredr, setListOredr] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate()


  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "Get_StationOrders", {
          code: 1,
          TokenId: userToken,
          Code_Meli: ""
        })

        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            setSeenFile(res.data.data);
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, [Stchange,requestId]);

  const toggleHandler = (id) => {
    if (isOpen)
    { 
      setIsOpen(false);
      setOrderId(0);
    }
    else
    {
       setIsOpen(true);
       setOrderId(id);
    }
  };

  const detailHandler = (index, val) => {
    const axios = require("axios");
    axios
      .post(apiUrl + "Get_DetailsOrders", {
        code: val,
        TokenId: userToken,
        Code_Meli: ""
      })

      .then((res) => {
        if (res.data.result === "true") {
          setListOredr(res.data.data);
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const deleteHandler = (val) => {
    const axios = require("axios");
    axios
      .post(apiUrl + "DeleteOrders", {
        code: val,
        TokenId: userToken,
        Code_Meli: "hfghfhggyd"
      })

      .then((res) => {
        if (res.data.result === "true") {
          if (Stchange) {
            setstchange(false)
          } else {
            setstchange(true)
          }
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const RadioHandlerChange = (val) => {
    setRadioItem(val);
  }


  return (
    <div>
      <main>
        <div className="pt-3 pt-lg-5">
          <Container className="m-auto">
            <Row className="justify-content-center mb-3">
              <Col xs={12} lg={10} className="mt-3">
                <Row className="justify-content-center  g-4">
                  <Col xs={12} style={{ direction: "ltr" }} className="my-3">
                    <Carousel
                      autoPlay={true}
                      showThumbs={false}
                      infiniteLoop={true}
                      interval={3000}
                    >
                      <div>
                        <img className="rgc-carousel" src={trash2} alt="trash2" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={trash3} alt="trash3" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={trash4} alt="trash4" />
                      </div>
                    </Carousel>
                  </Col>

                  <Col xs={12} className="sub-side p-0 m-0">

                    <div className="d-flex rgc-title">
                      <div className="rgc-title-point"></div>
                      <h4>سفارشات <span>در انتظار پذیرش</span></h4>
                    </div>

                  </Col>

                  <Col xs={12} className="text-center mt-3">
                    <BigLoaders loads={snip} />
                    <Accordion defaultActiveKey="0" flush >
                      {seenFile.length === 0 ?
                        <Col xs={12} className="rgc-orderreg-items rgc-score-body text-center" >
                          <span>سفارش موجود نیست</span>
                        </Col>
                        :
                        seenFile.map((data, index) => {
                          return (
                            <Accordion.Item className="rgc-driver-card"
                              key={index}
                              eventKey={index} onClick={() => detailHandler(index, data.Order_Id)}>
                              <Accordion.Header>
                                <Row className="juustify-content-start rgc-driver-info w-100 g-0">
                                  <Col xs={5} md={6} className="rgc-driver-image text-end text-md-center mt-2" >

                                    {data.img_Users == null ?
                                      <i className="fa fa-user-circle  rgc-avatar-icon" aria-hidden="true"></i>
                                      :
                                      <Image src={ProfileUrl + data.img_Users} className="rgc-avatar-driver" />

                                    }
                                  </Col>

                                  <Col xs={7} md={6} className="text-end mt-2">
                                    <div className="rgc-driver-btn rgc-orders-btn-edit"
                                      style={{ color: data.Color, background: data.Backcolor }} >
                                      <i class="fas fa-hourglass px-1"></i>
                                      {data.Stage_Tittle}
                                    </div>
                                  </Col>

                                  <Col xs={6} className="rgc-driver-txt text-end text-md-center">
                                    <div className="d-flex flex-column">
                                      <div>
                                        <span> نام: </span>
                                        <span>{data.Name}</span>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col xs={6} className="rgc-driver-txt text-end">
                                    <div className="d-flex flex-column">
                                      <div>
                                        <span>شماره تماس:</span>
                                        <span>{data.Mobile_User}</span>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col xs={12} className="rgc-weight py-2 text-center">
                                    <div className="d-flex justify-content-center rgc-contact">
                                      <a href={`tel:${data.Mobile_User}`}>
                                        <i className="fa fa-phone"></i>
                                      </a>
                                      <i class='fas fa-comments'></i>
                                      <i class="fa fa-map-marker-alt"></i>
                                    </div>

                                  </Col>

                                  <Col xs={12} className="rgc-driver-txt text-start">
                                    <div className="d-flex justify-content-end">
                                      <div className="rgc-driver-txt-items">
                                        <span>وزن کل:</span>
                                        <span>{data.Weight}</span>
                                      </div>

                                      <div>
                                        <span> مبلغ کل:</span>
                                        <span>{Intl.NumberFormat('en-US').format((data.Coint))}&nbsp;ریال</span>
                                      </div>

                                    </div>
                                  </Col>

                                </Row>
                              </Accordion.Header>
                              <Accordion.Body >
                                <hr />
                                <Row className="justify-content-start rgc-driver-content">
                                  {listOredr.map((data, index) => {
                                    return (
                                      <Col xs={12} lg={6} key={index} className="gx-md-5 gy-3">
                                        <Row className="rgc-driver-item g-0">
                                          <Col xs={2} className="text-center">
                                            <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                                          </Col>

                                          <Col xs={10} className="text-end">
                                            <span>{data.Type_Trash_Tittle}</span>
                                          </Col>

                                          <Col xs={6} className="text-center">
                                            <span>{data.Sub_Weight}</span><span>{data.Type_Weight_Title}</span>
                                          </Col>

                                          <Col xs={6} className="text-center">
                                            <span>{Intl.NumberFormat('en-US').format((data.Sub_Coint))}&nbsp;ریال</span>
                                          </Col>
                                        </Row>
                                      </Col>
                                    )
                                  })}
                                  <div className="w-100"></div>

                                  {/* <Col xs={6} md={4} className="text-center mt-3">
                                    <Button className="rgc-driver-btn rgc-driver-btn-remove"
                                      onClick={handleShow}
                                    >
                                      لغو سفارش
                                    </Button>
                                  </Col> */}

                                  <Col xs={6} md={4} className="text-center mt-3 m-auto" >
                                    <Button className="rgc-driver-btn rgc-driver-btn-edit"
                                      onClick={() => toggleHandler(data.Order_Id)}
                                    >
                                      ویرایش سفارش
                                    </Button>
                                  </Col>

                                </Row>
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                        })}
                    </Accordion>
                  </Col>



                  <Col xs={12} className="sub-side">

                    <Row onClick={toggleHandler} className="rgc-card g-0 rgc-order-card justify-content-center align-items-center">
                      <Col xs={3} className="rgc-item-img">
                        <img src={order}
                          alt=""
                          className="rgc-img-dash" />
                      </Col>

                      <Col xs={7} className="rgc-item-txt text-end">
                        <h4> ثبت سفارش جدید</h4>
                        <span> سفارش خود را برای جمع آوری زباله ثبت کنید</span>
                      </Col>
                      <Col xs={2} className="rgc-item-icon me-auto">
                        <i class="fa fa-angle-left"></i>
                      </Col>
                    </Row>

                  </Col>


                  <Col xs={12} className="sub-side">
                    <NavLink to="../wallet">
                      <Row className="rgc-card g-0 rgc-score-card justify-content-center align-items-center">
                        <Col xs={3} className="rgc-item-img">
                          <img src={score}
                            alt=""
                            className="rgc-img-dash" />
                        </Col>

                        <Col xs={7} className="rgc-item-txt text-end">
                          <h4> انتقال مبلغ</h4>
                          <span> شما می توانید مبالغ خود را انتقال دهید</span>
                        </Col>
                        <Col xs={2} className="rgc-item-icon me-auto">
                          <i class="fa fa-angle-left"></i>
                        </Col>
                      </Row>
                    </NavLink>
                  </Col>


                </Row>
              </Col>
            </Row>
          </Container>
          <OrderForm  order={orderId} toggle={isOpen} toggleHandler1={toggleHandler} />
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
